<template>
  <div id="cardDestiPhone">
    <div class="scroll-wrapper">
      <div class="grid-scroll-container">
        <div
          class="grid-page"
          v-for="(chunk, pageIndex) in chunkedRegions"
          :key="pageIndex"
        >
          <div
            v-for="(region, index) in chunk"
            :key="index"
            class="grid-item"
            :class="index % 2 === 0 ? '' : 'transform-card'"
            v-if="region.photo"
            @click="goToGroup('/destination/' + region.slug)"
          >
            <img :src="region.photo" :alt="region.name" />
            <a class="raleway-bold-p16">
              <p class="region-name text-center no-translate">{{ region.name }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarddestiPhone',
  props: ['regions'],
  computed: {
    chunkedRegions() {
      const chunkSize = 4;
      const chunks = [];
      for (let i = 0; i < this.regions.length; i += chunkSize) {
        chunks.push(this.regions.filter(x => x.photo && x.get_lodgings && x.get_lodgings.length > 0).slice(i, i + chunkSize));
      }
      return chunks;
    }
  },
  methods: {
    goToGroup(url) {
      window.open(url, '_blank');
    }
  },
};
</script>

<style scoped>
.scroll-wrapper {
  overflow-x: auto;
  scroll-snap-type: x mandatory;
}

.grid-scroll-container {
  display: flex;
  gap: 20px;
  padding-bottom: 1rem;
}

.grid-page {
  scroll-snap-align: start;
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 360px; /* Adjust width as needed for 2 items */
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;

  img {
   border-radius: 15px; 
  }
}

img {
  width: 100%;
  max-width: 170px;
  height: 160px;
  object-fit: cover;
}

.region-name {
  margin-top: 1rem;
  color: black;
}

.transform-card {
  padding-top: 30px;
}
</style>
